import type { tProduct } from 'src/shared/frontendTypes/product'
import { buildDefaultSelectedAttributes, buildSelectedAttributesFromOptions, normalizeSelectedAttributes } from './attributeAvailability'

export const buildInitialSelectedAttributes = (product: tProduct, variantKey?: string) => {
  const variant = variantKey
    ? product.combinations.find(combination => combination.key === variantKey)
    : undefined

  return normalizeSelectedAttributes(
    product,
    variant
      ? buildSelectedAttributesFromOptions(product, variant.options)
      : buildDefaultSelectedAttributes(product),
  )
}

